var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(this.$route.params.form_name === 'deleteRequest')?_c('ReviewDelete'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'personalForm'
    )?_c('ReviewInvestigator'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'vacationForm'
    )?_c('ReviewVacation'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'vinculationForm'
    )?_c('ReviewNewVinculation'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'modifyVinculationForm'
    )?_c('ReviewModifyVinculation'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'externalPeopleForm'
    )?_c('ReviewExternalPeople'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'newInvestigatorForm'
    )?_c('ReviewNewInvestigator'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'modifyExpirationDateForm'
    )?_c('ReviewModifyExpirationDate'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'modifyResponsibleForm'
    )?_c('ReviewModifyResponsible'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'modifyServicesForm'
    )?_c('ReviewModifyServices'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'modifyWorkplaceForm'
    )?_c('ReviewWorkplaceForm'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'workplaceAssignationForm'
    )?_c('ReviewExtendWorkplaceAssignation'):(this.$route.params.object_type === 'investigator' &&
  this.$route.params.form_name === 'affiliationForm')?_c('ReviewAffiliationForm'):(
      this.$route.params.object_type === 'publication' &&
        this.$route.params.form_name === 'newArticleForm'
    )?_c('ReviewNewArticle'):(this.$route.params.object_type === 'publication' &&
  this.$route.params.form_name === 'modifyBasicDataForm')?_c('ReviewModifyBasicData'):(this.$route.params.object_type === 'publication' &&
  this.$route.params.form_name === 'newBookAndChapterForm')?_c('ReviewNewBookAndChapter'):(this.$route.params.object_type === 'publication' &&
  this.$route.params.form_name === 'newCommunicationForm')?_c('ReviewCommunication'):(this.$route.params.object_type === 'publication' &&
  this.$route.params.form_name === 'newThesisForm')?_c('ReviewThesis'):(this.$route.params.object_type === 'project' &&
  (this.$route.params.form_name === 'newProjectForm' || this.$route.params.form_name === 'modifyProjectForm'))?_c('ReviewProjectForms'):(this.$route.params.object_type === 'news' &&
  (this.$route.params.form_name === 'newPressNewForm' || this.$route.params.form_name === 'modifyPressNewForm'))?_c('ReviewPressForms'):(this.$route.params.object_type === 'stay' &&
  (this.$route.params.form_name === 'newStayForm' || this.$route.params.form_name === 'modifyStayForm'))?_c('ReviewStayForms'):(this.$route.params.object_type === 'software' &&
  (this.$route.params.form_name === 'newSoftwareForm' || this.$route.params.form_name === 'modifySoftwareForm'))?_c('ReviewSoftwareForms'):(this.$route.params.object_type === 'dataset')?_c('ReviewDatasetForms'):(this.$route.params.object_type === 'industrial_property')?_c('ReviewIndustrialPropertyForms'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }